"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.auto.turn.detection': 'Rilevamento automatico del turno',
    'conversation.auto.turn.detection.help': 'Interrompi automaticamente la registrazione quando viene rilevato il silenzio',
};
